import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { RiMenu4Fill } from "react-icons/ri";
import styled from "styled-components";
import useScreenSize from "../hooks/useScreenSize";

const Navbar = () => {
    const [showMobileNav, setShowMobileNav] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
     const {width} = useScreenSize();

    const closeMobileNav = () => {
        setShowMobileNav(false);
        setShowEvents(false);
    };

    const toggleEvents = () => {
        if (width < 800) {
            setShowEvents(prev => !prev);
        }
    };

    return (
        <Header>

            <div
                className={`
                    nav-top
                    ${
                        showMobileNav && width < 800
                            ? "show-nav"
                            : "non-show-nav"
                    }
                    ${
                        width < 800
                            ? "potential-x"
                            : "no-potential-x"
                    }
                `}
            >

                {/* LOGO + MOBILE MENU */}

                <div className="nav-logomenu-wrapper">

                    <Link
                        to="/"
                        onClick={closeMobileNav}
                    >
                        <h2 className="logo">
                            AMRS
                        </h2>
                    </Link>

                    {showMobileNav ? (

                        <AiOutlineClose
                            className="menu-icon"
                            onClick={() =>
                                setShowMobileNav(false)
                            }
                        />

                    ) : (

                        <RiMenu4Fill
                            className="menu-icon"
                            onClick={() =>
                                setShowMobileNav(true)
                            }
                        />

                    )}

                </div>


                {/* NAVIGATION */}

                <nav
                    className={
                        showMobileNav && width < 800
                            ? "visible"
                            : "not-visible"
                    }
                >

                    <div
                        className={`
                            nav-links
                            ${
                                width < 800
                                    ? "scrollable-y"
                                    : "non-scrollable-y"
                            }
                        `}
                    >

                        <ul>

                            {/* NEWSLETTER */}

                            <li>
                                <NavLink
                                    to="/news"
                                    className={({ isActive }) =>
                                        isActive ? "active" : ""
                                    }
                                    onClick={closeMobileNav}
                                >
                                    Newsletter
                                </NavLink>
                            </li>


                            {/* EVENTS */}

                            <EventsDropdown
                                className={
                                    showEvents
                                        ? "events-open"
                                        : ""
                                }
                            >

                                <EventsButton
                                    type="button"
                                    onClick={toggleEvents}
                                >

                                    <span>
                                        Events
                                    </span>

                                    <DropdownArrow>
                                        ▾
                                    </DropdownArrow>

                                </EventsButton>


                                <EventsMenu>
                                    <EventsMenuPanel>
                                    <NavLink
                                        to="/amrs-dec-2026-workshop"
                                        style={({ isActive }) => ({
                                            color: isActive ? "var(--primary-color)" : undefined,
                                        })}
                                        onClick={closeMobileNav}
                                    >
                                        AMRS DEC Workshop 2026
                                    </NavLink>

                                    <NavLink
                                        to="/amrs-jun-2026-workshop"
                                        style={({ isActive }) => ({
                                            color: isActive ? "var(--primary-color)" : undefined,
                                        })}
                                        onClick={closeMobileNav}
                                    >
                                        AMRS JUN Workshop 2026
                                    </NavLink>


                                    <NavLink
                                        to="/iumrs-icam25"
                                        style={({ isActive }) => ({
                                            color: isActive ? "var(--primary-color)" : undefined,
                                        })}
                                        onClick={closeMobileNav}
                                    >
                                        IUMRS-ICAM 2025
                                    </NavLink>


                                    </EventsMenuPanel>
                                </EventsMenu>

                            </EventsDropdown>


                            {/* DONATIONS */}

                            <li>
                                <a
                                    href="https://paystack.com/pay/amrsghana_donations"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Donations
                                </a>
                            </li>

                        </ul>

                    </div>


                    {/* PROFILE BUTTONS */}

                    <div className="more-nav-options">

                        <NavLink
                            to="/login"
                            className="login-btn"
                            onClick={closeMobileNav}
                        >
                            Verify Profile
                        </NavLink>


                        <NavLink
                            to="/signup"
                            className="signup-btn"
                            onClick={closeMobileNav}
                        >
                            Submit Profile
                        </NavLink>

                    </div>

                </nav>

            </div>

        </Header>
    );
};


const Header = styled.header`
    position: sticky;
    overflow: visible;
    top: 0;
    left: 0;
    width: 100%;
    background-color: black;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 1000;
    .show-nav{
        background-color: var(--color-black-light);
    }
    .nav-top{
        position: relative;
        margin: 0; 
        overflow : visible;
        .nav-logomenu-wrapper{
            width: 100vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .logo{
                color: white;
                font-size: 2rem;
                margin-left:1.5em ;
            }
            .menu-icon{
            margin-right: 2em;
            font-size: 1.3rem;
            padding: 0.8em;
            transition: all 0.3s ease-in-out;
            color: white;
            &:hover{
                cursor: pointer;
                border-radius: 50%;
                box-shadow:  0.3em 0.3em 1em rgba(0, 0, 0, 0.3);
                }
            }
        }
    }
    nav{
        position: absolute;
        /* background-color: transparent; */
        top:6em;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow-x: hidden;
        z-index: 100;
        border-top: 1px solid var(--color-muted-black);
    animation-name: navFadeIn;
    animation-duration: 0.4s;
    animation-fill-mode: none;
        .nav-links{
            ul{
                padding: 0 2em;
                width: 100%;
                list-style-type: none;
                li{
                    padding:1em 0;
                    font-weight : 500;
                    a{
                        color: var(--color-white);
                        &:hover{
                            color: var(--primary-color);
                        }
                    }
                    .active{
                        color: var(--primary-color);
                    }
                }
            }
        } 
        .more-nav-options{
            box-shadow:  0.3em 0.3em 1em rgba(0, 0, 0, 0.3);
            background-color: transparent;
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 1em 0;
            a{
                font-size: 1.2rem;
                border-radius: 50px;
                width: 50%;
                text-align: center;
                margin: 0.6em 0;
                padding: 0.6em 0;
                
            }
            .login-btn{
                color: var(--primary-color);
                border: 1px solid var(--primary-color);
            }
            .signup-btn{
                color:var(--color-white);
                background-color: var(--primary-color);
            }
        }
    }
    /* if there is a potential exist for a show mobile nav but not visible, then display none */
    .potential-x{
        .not-visible{
        display:none;
    }
    }
    .visible{ background-color: var(--color-black-light);}

      /* Animations */
    @keyframes navFadeIn{
    from{
        opacity: 0;
        transform: translateY(-12px);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}


    /* Media Queries */
    @media only screen and (min-width: 800px){
        display: flex;
        flex-direction: column;
        .nav-top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            .nav-logomenu-wrapper{
                width: unset;
            }
        }
        .logo{
            margin-left: 4em;
        }
        .menu-icon{
            display: none;
        }
        nav{
            display: flex;
            align-items: center;
            justify-content: end;
            position: unset;
            height: unset;
            border-top: unset;
            overflow: visible;
            .nav-links{
                width: 100%;
                padding: 0;
                overflow: visible;
                ul{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 2em;
                    overflow: visible;
                    li{
                        padding: unset;
                    }
                }
            }
            .more-nav-options{
                position: unset;
                padding: unset;
                box-shadow: unset;
                display: flex;
                justify-content: center;
                flex-direction: row;
                gap: 0.7em;
                
                .signup-btn{
                    width: 30%;
                }
                .login-btn{
                    width: 30%;
                }
            }
        }
    }

    @media only screen and (min-width: 1200px){
        nav{
            .more-nav-options{
                width: 70%;
                a{
                    font-size: 1rem;
                    width: 50%;
                }
            }
        }
    }

    @media only screen and (min-width: 1500px){
        .logo{
            margin-left: 7em;
        }
    }

/* NOTE: Media Query for screen height change conditions */
@media only screen and (max-height: 600px){
    .scrollable-y{
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        height: 30vh;
        &::-webkit-scrollbar {
            width: 0.5em;
        }
        &::-webkit-scrollbar-thumb {
            background-color: var(--color-muted-black-light);
            border-radius: 50px;
            &:hover{
                background-color: var(--color-muted-black);
            } 
        }
    }
}
`;

const EventsDropdown = styled.li`
    position: relative;
    overflow: visible;
`;

const EventsButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;

    color: #fff;
    font-family: inherit;
    font-size: 15px;
    font-weight: 600;

    display: flex;
    align-items: center;
    gap: 6px;

    cursor: pointer;

    transition: color 0.2s ease;

    &:hover {
        color: #d6a52c;
    }
`;

const DropdownArrow = styled.span`
    display: inline-block;
    font-size: 13px;
    line-height: 1;
    transition: transform 0.25s ease;

    /* Mobile: rotate when the dropdown is toggled open via state */
    @media only screen and (max-width: 799px) {
        ${EventsDropdown}.events-open & {
            transform: rotate(180deg);
        }
    }

    /* Desktop: rotate on hover, independent of any leftover mobile state */
    @media only screen and (min-width: 800px) {
        ${EventsDropdown}:hover & {
            transform: rotate(180deg);
        }
    }
`;

const EventsMenu = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 240px;
    padding-top: 15px;

    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 99999;

    transition: opacity 0.2s ease, visibility 0.2s ease;

    ${EventsDropdown}:hover & {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }

    @media only screen and (max-width: 799px) {
        position: static;
        width: 100%;
        left: auto;
        transform: none;
        max-height: 0;
        padding: 0;
        overflow: hidden;
        transition: max-height 0.3s ease, opacity 0.2s ease, visibility 0.2s ease;

        ${EventsDropdown}.events-open & {
            max-height: 300px;
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
        }
    }
`;

const EventsMenuPanel = styled.div`
    background: #111;
    border: 1px solid rgba(214, 165, 44, 0.5);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);

    a {
        display: block;
        padding: 13px 20px;
        color: white;
        text-decoration: none;
        font-size: 11px;
        white-space: nowrap;
        transition: color 0.2s ease;

        &:hover {
            color: var(--primary-color);
        }
    }



    @media only screen and (max-width: 799px) {
        background: transparent;
        border: none;
        box-shadow: none;

        a {
            padding: 15px 20px;
            font-size: 11px;
            border-top: 1px solid rgba(255, 255, 255, 0.06);
        }
    }
`;
export default Navbar;